// TODO: create ErrorSchemas that can be imported here
// type LiteralKeys<T> = Required<T>[keyof T]

const strings = {
	title: "My Card Collection",
	cards: "Cards",
	learningUnits: "Learning Units",
}
export default strings
export type CardCollectionL10nStrings = typeof strings
